import useUser from "../../../hooks/use-user";
import React, { useState, useEffect } from "react";
import { toast } from "../../../helpers/message-helper";

import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    ListGroup,
    ListGroupItem,
} from "reactstrap";
import HeaderRun from "./Header.run";

const Header = () => {
    const { getUserData } = useUser();
    const userData = getUserData();

    useEffect(() => HeaderRun(), []);

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const { logout } = useUser();

    const resize = () => {
        // all IE friendly dispatchEvent
        var evt = document.createEvent("UIEvents");
        evt.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(evt);
        // modern dispatchEvent way
        // window.dispatchEvent(new Event('resize'));
    };

    // Añade o borra una clase a un elemento dependiendo si su stat es true
    const updateElementClass = (el, stat, name) =>
        el && el.classList[stat ? "add" : "remove"](name);
    // Actualiza clases del body dependiendo de la configuración especificada
    const updateBodyClass = (stat, name) =>
        updateElementClass(document.body, stat, name);

    const toggleAside = (e) => {
        e.preventDefault();
        updateBodyClass(!isSidebarCollapsed, "aside-toggled");
        setIsSidebarCollapsed((prev) => !prev);
        resize();
    };

    const onLogout = () => {
        const resp = logout();

        if (!resp) {
            toast.error('Ha ocurrido un error al cerrar la sesión');
        }
    };

    return (
        <header className="topnavbar-wrapper">
            {/* START Top Navbar */}
            <nav className="navbar topnavbar">
                {/* START navbar header */}
                <div className="navbar-header">
                    <a className="navbar-brand" href="#/">
                        <div className="brand-logo">
                            <img
                                className="img-fluid"
                                src="img/logo-csr-white.png"
                                width="80px"
                                alt="App Logo"
                            />
                        </div>
                        <div className="brand-logo-collapsed">
                            <img
                                className="img-fluid"
                                src="img/logo_csr_big_white.png"
                                width="80px"
                                alt="App Logo"
                            />
                        </div>
                    </a>
                </div>
                {/* END navbar header */}
                {/* START Left navbar */}
                <ul className="navbar-nav mr-auto flex-row">
                    <li className="col-2 col-lg-2 nav-item d-md-none">
                        {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                        <a
                            href=""
                            className="nav-link sidebar-toggle"
                            onClick={toggleAside}
                        >
                            <em className="fas fa-bars"></em>
                        </a>
                    </li>
                    <h1 className="text-center text-white mt-1 h3">
                        Centro de Apoyo Nuevo
                    </h1>
                </ul>
                <div className="text-right">
                    <h4 className="text-right text-white mt-1 mr-2">
                        Hola {userData?.nombres + ' ' + userData.apellidos ?? ""}
                    </h4>
                </div>
                {/* END Left navbar */}
                {/* START Right Navbar */}
                <ul className="navbar-nav flex-row">
                    {/* Search icon */}
                    {/*<li className="nav-item">
                        <a className="nav-link" href="" data-search-open="">
                            <em className="icon-magnifier"></em>
                        </a>
                    </li>*/}
                    {/* Cambiar de tema */}
                    {/* <li className="nav-item">
                        <a
                            className="nav-link"
                            href=""
                            onClick={(e) => toggleOffsidebar(e)}
                        >
                            <em className="fas fa-moon"></em>
                        </a>
                    </li> */}
                    {/* START Alert menu */}
                    <UncontrolledDropdown
                        nav
                        inNavbar
                        className="dropdown-list"
                    >
                        <DropdownToggle nav className="dropdown-toggle-nocaret">
                            <em className="icon-bell"></em>
                            <span className="badge badge-danger">0</span>
                        </DropdownToggle>
                        {/* START Dropdown menu */}
                        <DropdownMenu
                            right
                            className="dropdown-menu-right animated flipInX"
                        >
                            <DropdownItem>
                                {/* START list group */}
                                <ListGroup>
                                    <ListGroupItem
                                        action
                                        tag="a"
                                        href=""
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <div className="media">
                                            <div className="align-self-start mr-2">
                                                <em className="fa fa-envelope fa-2x text-warning"></em>
                                            </div>
                                            <div className="media-body">
                                                <p className="m-0">
                                                    Notificaciones
                                                </p>
                                                <p className="m-0 text-muted text-sm">
                                                    0 Notificaciones
                                                </p>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                    <ListGroupItem
                                        action
                                        tag="a"
                                        href=""
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <div className="media">
                                            <div className="align-self-start mr-2">
                                                <em className="fa fa-tasks fa-2x text-success"></em>
                                            </div>
                                            <div className="media-body">
                                                <p className="m-0">
                                                    Alertas
                                                </p>
                                                <p className="m-0 text-muted text-sm">
                                                    0 Pendientes
                                                </p>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                </ListGroup>
                                {/* END list group */}
                            </DropdownItem>
                        </DropdownMenu>
                        {/* END Dropdown menu */}
                    </UncontrolledDropdown>
                    {/* END Alert menu */}
                    {/* START Offsidebar button */}
                    <li className="nav-item" onClick={onLogout} title="Cerrar Sesion" alt="Cerrar Sesion">
                        <span className="nav-link" >
                            <em className="icon-logout"></em>
                        </span>
                    </li>
                    {/* END Offsidebar menu */}
                </ul>
                {/* END Right Navbar */}

                {/* START Search form */}
                <form
                    className="navbar-form"
                    role="search"
                    action="search.html"
                >
                    <div className="form-group">
                        <input
                            className="form-control"
                            type="text"
                            placeholder="Type and hit enter ..."
                        />
                        <div
                            className="fa fa-times navbar-form-close"
                            data-search-dismiss=""
                        ></div>
                    </div>
                    <button className="d-none" type="submit">
                        Submit
                    </button>
                </form>
                {/* END Search form */}
            </nav>
            {/* END Top Navbar */}
        </header>
    );
};

export default Header;
